
import { ReactNode } from 'react';
import { MainNav } from "@/components/MainNav";
import { PageSEO } from "@/components/PageSEO";
import { isSSR } from "@/lib/isSSR";

interface BlogLayoutProps {
  children: ReactNode;
  title: string;
  description: string;
  canonicalPath: string;
  structuredData?: any;
  ssrMode?: boolean;
}

export const BlogLayout = ({ 
  children, 
  title, 
  description, 
  canonicalPath,
  structuredData,
  ssrMode = false
}: BlogLayoutProps) => {
  // Detect if we're in SSR mode
  const isServerRendering = ssrMode || isSSR();
  return (
    <div className="min-h-screen flex flex-col">
      <PageSEO 
        title={title}
        description={description}
        canonicalPath={canonicalPath}
        structuredData={structuredData}
        ssrMode={isServerRendering}
      />

      <MainNav />
      <main className="flex-1 container mx-auto py-6 px-4 md:px-6">
        {children}
      </main>
    </div>
  );
};
